export interface UpdatePropertyTypeRequest {
  subject_property_type?: PropertyTypes | null;
  is_located_within_a_project?: boolean;
  project_classification?: string;
  is_mixed_use?: boolean;
  level_of_property_review?: LevelOfPropertyReviewEnum;
  appraisal_report_form_number?: AppraisalReportFormNumberEnum;
}

export enum PropertyTypes {
  SFR = "SFR",
  SFRATT = "SFR-ATT",
  PUD = "PUD",
  PUDATT = "PUD-ATT",
  SiteCondo = "Site Condo",
  LowRiseCondo = "Low-Rise Condo",
  MidRiseCondo = "Mid-Rise Condo",
  HighRiseCondo = "High-Rise Condo",
  Duplex = "Duplex",
  DuplexATT = "Duplex-ATT",
  Triplex = "Triplex",
  TriplexATT = "Triplex-ATT",
  Quadplex = "Quadplex",
  QuadplexATT = "Quadplex-ATT",
}

export const PropertyOccupancyDisplayValues = {
  primary: "Primary",
  secondary: "Secondary",
  neither: "Neither",
};

export const PropertyTypeDisplayValues = {
  [PropertyTypes.SFR]: "SFR",
  [PropertyTypes.SFRATT]: "SFR-ATT",
  [PropertyTypes.PUD]: "PUD",
  [PropertyTypes.PUDATT]: "PUD-ATT",
  [PropertyTypes.SiteCondo]: "Site Condo",
  [PropertyTypes.LowRiseCondo]: "Low-Rise Condo",
  [PropertyTypes.MidRiseCondo]: "Mid-Rise Condo",
  [PropertyTypes.HighRiseCondo]: "High-Rise Condo",
  [PropertyTypes.Duplex]: "Duplex",
  [PropertyTypes.DuplexATT]: "Duplex-ATT",
  [PropertyTypes.Triplex]: "Triplex",
  [PropertyTypes.TriplexATT]: "Triplex-ATT",
  [PropertyTypes.Quadplex]: "Quadplex",
  [PropertyTypes.QuadplexATT]: "Quadplex-ATT",
};

export const PropertyTypesLocatedInAProject: PropertyTypes[] = [
  PropertyTypes.HighRiseCondo,
  PropertyTypes.LowRiseCondo,
  PropertyTypes.MidRiseCondo,
  PropertyTypes.PUD,
  PropertyTypes.PUDATT,
  PropertyTypes.SiteCondo,
];

export enum LevelOfPropertyReviewEnum {
  ExteriorInterior = "ExteriorAndInterior",
  ExteriorOnly = "ExteriorOnly",
  NoAppraisal = "None",
}

export const LevelOfPropertyReviewDisplayValues = {
  [LevelOfPropertyReviewEnum.ExteriorInterior]: "Exterior/Interior",
  [LevelOfPropertyReviewEnum.ExteriorOnly]: "Exterior Only",
  [LevelOfPropertyReviewEnum.NoAppraisal]: "No Appraisal",
};

export enum AppraisalReportFormNumberEnum {
  UniformResidential = "1004",
  ManufacturedHome = "1004C",
  AppraisalUpdate = "1004D",
  SmallResidentialIncomeProperty = "1025",
  IndividualCondominiumUnit = "1073",
  IndividualCooperativeInterest = "2090",
}

export const AppraisalReportFormNumberDisplayValues = {
  [AppraisalReportFormNumberEnum.UniformResidential]: "1004: Uniform Residential",
  [AppraisalReportFormNumberEnum.ManufacturedHome]: "1004C: Manufactured Home",
  [AppraisalReportFormNumberEnum.AppraisalUpdate]:
    "1004D: Appraisal Update and/or Completion Report",
  [AppraisalReportFormNumberEnum.SmallResidentialIncomeProperty]:
    "1025: Small Residential Income Property",
  [AppraisalReportFormNumberEnum.IndividualCondominiumUnit]: "1073: Individual Condominium Unit",
  [AppraisalReportFormNumberEnum.IndividualCooperativeInterest]:
    "2090: Individual Cooperative interest",
};
